import { useCallback, useMemo } from 'react';
import { useGetDiscountsForFilters } from '../../api/api';

export const useFilterDiscountsTitleByValue: (values: string[]) => { value: string; title: string }[] = (values) => {
    const { data } = useGetDiscountsForFilters();

    const getTitle = useCallback(
        (id: string) => (data ?? []).find((discount) => discount.id === id)?.title ?? id,
        [data]
    );

    return useMemo(
        () =>
            values.map((value) => {
                return { value, title: getTitle(value) };
            }),
        [getTitle, values]
    );
};
